import { ScheduledReportFrequency } from 'dashboard/enums/scheduled-report-frequency.enum';

export const scheduledReportFrequencyTranslationMap = {
    [ScheduledReportFrequency.DAILY]: 'dashboard.scheduledReports.frequency.daily',
    [ScheduledReportFrequency.WEEKLY]: 'dashboard.scheduledReports.frequency.weekly',
    [ScheduledReportFrequency.MONTHLY]: 'dashboard.scheduledReports.frequency.monthly',
    [ScheduledReportFrequency.MANUAL]: 'dashboard.scheduledReports.frequency.manual',
};
